import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'mat-checkbox, mat-radio-button',
  standalone: false,
})
export class BlurOnReleaseDirective {
  constructor() {}

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: Event) {
    (event.target as HTMLElement).blur();
  }
}
